import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useDispatch, useSelector } from "react-redux";
import {
  SidesheetType,
  closeSidesheet,
  selectCurrentSidesheet,
} from "store/calendarSidebarSlice";
import getClasses from "utils/getClasses";
import AddToCalendar from "../components/add-to-calendar/AddToCalendar";
import BlockedIntervalSidesheet from "../components/blocked-interval-sidesheet/BlockedIntervalSidesheet";
import DayPreview from "../components/day-preview/DayPreview";
import GCalEventDetails from "../components/gcal-event-details/GCalEventDetails";
import SessionSidesheet from "../components/session-sidesheet/SessionSidesheet";
import styles from "./SidesheetContainer.module.scss";
import { useMemo } from "react";

const SidesheetContainer = () => {
  const { isPhonePortrait } = usePhonePortraitContext();

  const currentSidesheet = useSelector(selectCurrentSidesheet);
  const dispatch = useDispatch();

  const isHidden = currentSidesheet === SidesheetType.None;

  const content = useMemo(() => {
    switch (currentSidesheet) {
      case SidesheetType.AddToCalendar:
        return <AddToCalendar />;
      case SidesheetType.BlockedIntervalDetails:
      case SidesheetType.EditBlockedInterval:
        return <BlockedIntervalSidesheet />;
      case SidesheetType.DayPreview:
        return <DayPreview />;
      case SidesheetType.GcalEventDetails:
        return <GCalEventDetails />;
      case SidesheetType.SessionDetails:
      case SidesheetType.EditSession:
        return <SessionSidesheet />;
      default:
        return null;
    }
  }, [currentSidesheet]);

  return (
    <div
      className={getClasses(
        isHidden && styles.hidden,
        isPhonePortrait ? styles.phone : styles.desktop,
        currentSidesheet === SidesheetType.AddToCalendar &&
          styles["add-to-calendar"],
      )}
      onClick={(event) => {
        if (event.target !== event.currentTarget) {
          return;
        }

        dispatch(closeSidesheet());
      }}
    >
      {content}
    </div>
  );
};

export default SidesheetContainer;
